module.exports = __webpack_public_path__ + "img/bilgisayar-markalari.d05e1641.jpg";